export const cookieAction = (props) => {
    return {
        storeSession: (data) => {
            props.dispatch({ type: SESSION, data });
        },
    };
};

const SESSION = 'SESSION';

export { SESSION };
